export default __webpack_public_path__ + "static/FrameDream-Logo-9c9bb7dbf359a201d17aebd1af47f264.png";